import { createSlice } from "@reduxjs/toolkit";
import {
  fetchBlogs,
  fetchBlogById,
  createNewBlog,
  updateExistingBlog,
  deleteBlogById,
  FeaturedBlogs,
} from "./blogThunk";

const initialState = {
  blogs: [],
  selectedBlog: null,
  loading: false,
  error: null,
  featuredBlogs: [],
};

const blogSlice = createSlice({
  name: "blogs",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Get all blogs
      .addCase(fetchBlogs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBlogs.fulfilled, (state, action) => {
        state.loading = false;
        state.blogs = action.payload || [];
      })
      .addCase(fetchBlogs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Get one blog
      .addCase(fetchBlogById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBlogById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedBlog = action.payload;
      })
      .addCase(fetchBlogById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Create blog
      .addCase(createNewBlog.fulfilled, (state, action) => {
        state.blogs.push(action.payload);
      })

      // Update blog
      .addCase(updateExistingBlog.fulfilled, (state, action) => {
        /* 
        const index = state.blogs.findIndex((b) => b.id === action.payload.id);
        if (index !== -1) state.blogs[index] = action.payload;
        */
      })

      // Delete blog
      .addCase(deleteBlogById.fulfilled, (state, action) => {
        state.blogs = state.blogs.filter((b) => b.id !== action.payload);
      })

      //Featured blogs
      .addCase(FeaturedBlogs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(FeaturedBlogs.fulfilled, (state, action) => {
        state.featuredBlogs = action.payload || [];
        state.loading = false;
      })
      .addCase(FeaturedBlogs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default blogSlice.reducer;
